'use client';

import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import { Bars3Icon } from '@heroicons/react/20/solid';
import { User } from '@supabase/supabase-js';
import { CareerMap } from '../../typesV2';
import { useHydrateAtoms } from 'jotai/utils';
import { useAtom } from 'jotai';
import {
  applicationStateAtom,
  desktopSidebar,
  mapDataAtom,
  mobileSidebar,
} from '../../jotaiStore';
import LoginButton from '../global/LoginButton';
import { useParams, useSearchParams } from 'next/navigation';
import SaveMapButton from '../global/SaveMapButton';
import ShareMapButton from '../ShareMapButton';

const MemoizedJobTitle: React.FC = ({}) => {
  useHydrateAtoms([[mapDataAtom, null]]);
  const [streamMapData, setMapIntro] = useAtom(mapDataAtom);

  let objectValue: any = streamMapData;

  const MemoizedTitleTitle = React.useMemo(() => {
    return objectValue?.jobTitle;
  }, [objectValue?.jobTitle]);

  return MemoizedTitleTitle;
};

type MapTopNavbarProps = {
  user: User | null;
  activeMap: CareerMap | null;
  isRoadMap?: boolean;
  className?: string;
};

const MapTopNavbar: React.FC<MapTopNavbarProps> = ({
  user,
  activeMap,
  isRoadMap = false,
  className,
}) => {
  useHydrateAtoms([
    [mobileSidebar, false],
    [desktopSidebar, true],
  ]);
  const isShowIntro = useSearchParams().get('showIntro');
  const contentSlug = useParams().contentSlug;
  const [showMobileSidebar, setShowMobileSidebar] = useAtom(mobileSidebar);
  const [showDesktopSidebar, setShowDesktopSidebar] = useAtom(desktopSidebar);

  return (
    <>
      <div className={clsx("hidden min-[1200px]:flex z-40 h-[54px] shrink-0 items-center gap-x-4 bg-colors-green shadow-sm w-full pr-3", className)}>
        {/* MOBILE SIDE BAR ICON */}

        <nav className="self-stretch flex-1">
          {/* DESKTOP */}
          <div
            className={clsx(
              // !showDesktopSidebar && '-translate-x-2',
              'hidden min-[1200px]:flex grow items-center relative transition-all w-full h-full'
            )}
          >
            <div className="min-w-[300px]">
              <Link href="/" className="">
                <h1 className="text-[24px] font-semibold tracking-[0.22em] ml-0.5 text-shades-base/95 text-left cursor-pointer mt-[2px]">
                  <div className="flex justify-center">
                    CAREER
                    <span className="pl-[2px] ">MAPPER</span>
                  </div>
                </h1>
              </Link>
            </div>
            {!isRoadMap && (
              <>
                {/* <div
                  className={clsx(
                    !showDesktopSidebar ? '-translate-x-1 h-6 ' : 'h-[54px]',
                    ' w-px -ml-[1px] bg-shades-base/15 relative justify-center transition-all'
                  )}
                  aria-hidden="true"
                /> */}
                {/* <h2
                  className={clsx(
                    !showDesktopSidebar && '-translate-x-1',
                    'relative text-shades-baseLight text-lg font-light w-full grow ml-[18px] transition-all'
                  )}
                >
                  How to become a <MemoizedJobTitle />
                </h2> */}
              </>
            )}
            <div className="flex justify-end items-start pt-1 mr-0.5 w-full"></div>
            {/* <div className="flex items-center justify-end mr-4">
              <ShareMapButton />
            </div> */}
            <div className="flex items-start justify-end pt-1 mr-4">
              <SaveMapButton user={user} homepageOnly={false} />
            </div>

            <div className="flex justify-end items-start pt-1 mr-0.5">
              <LoginButton user={user} homepageOnly={false} />
            </div>
          </div>

          {/* MOBILE */}
        </nav>
      </div>
      <div className={clsx("flex items-center justify-start w-full gap-4 px-4 bg-colors-green min-", className)}>
        <div
          className={clsx(
            'flex justify-start items-center gap-4 min-[1000px]:hidden',
            !isShowIntro && !contentSlug && 'max-[1000px]:hidden'
          )}
        >
          <button
            type="button"
            className="text-gray-700 min-[1000px]:hidden hover:scale-110 transition-all z-[40]"
            onClick={() => setShowMobileSidebar(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon className="h-9 w-9" aria-hidden="true" />
          </button>
          <div
            className="h-6 w-px bg-gray-900/10 min-[1200px]:hidden"
            aria-hidden="true"
          />
        </div>

        <div className="min-[1200px]:hidden flex items-center w-full h-[54px] bg-colors-green z-50">
          <Link href="/">
            <h1 className="text-2xl mt-px text-shades-baseLight text-left cursor-pointer font-semibold tracking-[0.19em]">
              CAREER
              <span className="pl-[3px]">MAPPER</span>
            </h1>
          </Link>
          <div className="flex justify-end items-start pt-1 mr-0.5 w-full"></div>
          {/* <ShareMapButton /> */}

          <div className="flex justify-end items-start pt-1 mr-4 max-[600px]:hidden">
            <SaveMapButton user={user} homepageOnly={false} />
          </div>
          <div className="flex justify-end items-start pt-1 -mr-0.5 max-[550px]:hidden">
            <LoginButton user={user} homepageOnly={false} />
          </div>
          {/* <h2 className="w-full font-light leading-4 text-shades-baseLight">
              How to become a <MemoizedJobTitle />
            </h2> */}
        </div>
      </div>
    </>
  );
};

export default MapTopNavbar;
